import react, { useState, useEffect } from 'react';
import { supabase } from '../supabaseclient';

export default function Estoque() {
  const [itens, setitens] = useState([]);
  const [loading, setloading] = useState(false);

  // 1. busca o saldo atual de todos os itens no banco de dados
  useEffect(() => {
    carregarestoque();
  }, []);

  const carregarestoque = async () => {
    const { data, error } = await supabase
      .from('estoque')
      .select('*')
      .order('item', { ascending: true });
    
    if (!error) setitens(data);
  };

  // 2. função para registrar entrada de novas doações (aumenta o saldo)
  const handleentradaestoque = async (e) => {
    e.preventDefault();
    setloading(true);
    const fd = new FormData(e.target);
    
    const itemnome = fd.get('item');
    const qtdadicionar = parseInt(fd.get('quantidade'));

    // localiza o item atual no estado para calcular o novo saldo
    const itematual = itens.find(i => i.item === itemnome);
    const novosaldo = (itematual?.saldo_atual || 0) + qtdadicionar;

    // atualiza no supabase
    const { error } = await supabase
      .from('estoque')
      .update({ saldo_atual: novosaldo })
      .eq('item', itemnome);

    if (!error) {
      alert(`estoque de ${itemnome} atualizado com sucesso!`);
      carregarestoque(); // atualiza os cards na tela
      e.target.reset();
    } else {
      alert("erro ao atualizar estoque: " + error.message);
    }
    setloading(false);
  };

  return (
    <div className="max-w-5xl mx-auto space-y-8">
      {/* visualização de saldos (cards) */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {itens.map((item) => (
          <div 
            key={item.id} 
            className={`bg-white p-6 rounded-3xl shadow-lg border-b-8 transition-transform hover:scale-105 ${
              item.saldo_atual <= item.ponto_critico ? 'border-red-600' : 'border-blue-900'
            }`}
          >
            <p className="text-[10px] font-black text-gray-400 uppercase tracking-widest mb-1">
              saldo atual
            </p>
            <h3 className="text-lg font-bold text-gray-800 uppercase leading-tight mb-2">
              {item.item}
            </h3>
            <p className={`text-5xl font-black ${
              item.saldo_atual <= item.ponto_critico ? 'text-red-600' : 'text-blue-900'
            }`}>
              {item.saldo_atual}
            </p>
            {item.saldo_atual <= item.ponto_critico && (
              <div className="mt-4 bg-red-50 p-2 rounded-lg border border-red-100 animate-pulse">
                <p className="text-[10px] text-red-700 font-bold text-center uppercase">
                  ⚠️ estoque crítico! providenciar reposição
                </p>
              </div>
            )}
          </div>
        ))}
      </div>

      {/* formulário para entrada de doações */}
      <div className="bg-white p-6 md:p-8 rounded-3xl shadow-lg border border-gray-100">
        <header className="border-b pb-4 mb-6">
          <h2 className="text-2xl font-black text-blue-900 uppercase tracking-tight">📥 entrada de doações</h2>
          <p className="text-xs text-gray-500 font-bold uppercase underline">abastecimento do depósito fundo social</p>
        </header>

        <form onSubmit={handleentradaestoque} className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div className="md:col-span-2">
            <label className="text-[10px] font-black text-gray-400 uppercase ml-1">selecione o item recebido</label>
            <select name="item" className="input-field" required>
              <option value="Cesta Grande">Cesta Grande</option>
              <option value="Cesta Pequena">Cesta Pequena</option>
              <option value="Leite">Leite</option>
            </select>
          </div>

          <div>
            <label className="text-[10px] font-black text-gray-400 uppercase ml-1">quantidade recebida</label>
            <input name="quantidade" type="number" className="input-field font-bold" required placeholder="ex: 100" />
          </div>

          <button 
            disabled={loading}
            className="md:col-span-3 bg-blue-700 hover:bg-blue-800 text-white font-black py-4 rounded-2xl shadow-xl transition-all active:scale-95"
          >
            {loading ? "processando..." : "confirmar entrada no estoque"}
          </button>
        </form>
      </div>
    </div>
  );
}
